import validate from "/runner/_work/merpay-coupon-web-jp/merpay-coupon-web-jp/node_modules/.pnpm/nuxt@3.8.2_vue-tsc@1.8.19/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/runner/_work/merpay-coupon-web-jp/merpay-coupon-web-jp/modules/app/src/middleware/redirect.global.ts";
import manifest_45route_45rule from "/runner/_work/merpay-coupon-web-jp/merpay-coupon-web-jp/node_modules/.pnpm/nuxt@3.8.2_vue-tsc@1.8.19/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  detail: () => import("/runner/_work/merpay-coupon-web-jp/merpay-coupon-web-jp/modules/app/src/middleware/detail.ts")
}